module.exports = __webpack_public_path__ + "static/img/6.a8ff070.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/6.png
// module id = eQWj
// module chunks = 0